import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import type { RootState } from '../../../state/store';
import { getAv2Colors, type Av2Colors, type ThemeMode } from './constants';

export const useAv2Colors = (): Av2Colors => {
  const theme = useTheme();
  if (theme.av2) return theme.av2;
  const mode = useSelector((state: RootState) => state.theme?.mode || 'light') as ThemeMode;
  return getAv2Colors(mode);
};

export const useAv2ThemeMode = (): ThemeMode => {
  const theme = useTheme();
  if (theme.mode === 'light' || theme.mode === 'dark') return theme.mode;
  return useSelector((state: RootState) => state.theme?.mode || 'light') as ThemeMode;
};
